import $ from "jquery";

export default {
  locale: "US",
  currency: "$",

  configureLocale(locale, currency, timezoneIdentifier) {
    this.locale = locale;
    this.currency = currency;
    this.timezone = timezoneIdentifier;
  },

  getCSRFToken() {
    return $("meta[name='csrf-token']").attr("content");
  }
};
